
    <div class="legend-title">
        Annual Birth Rates by World Region
    </div>
    <div class="legend">
        <igx-legend
        name="Legend"
        #legend
        orientation="Horizontal">
        </igx-legend>
    </div>
    <div style="width:100%;height:800px;">
        <igx-data-chart
        name="chart"
        #chart
        [legend]="legend"
        isHorizontalZoomEnabled="false"
        isVerticalZoomEnabled="false">
            <igx-category-x-axis
            name="xAxis"
            #xAxis
            [dataSource]="continentsBirthRate"
            label="year"
            gap="0.75">
            </igx-category-x-axis>
            <igx-numeric-y-axis
            name="yAxis"
            #yAxis
            minimumValue="0"
            maximumValue="140"
            interval="20"
            titleLeftMargin="10"
            labelFormat="{0} m">
            </igx-numeric-y-axis>
            <igx-stacked-column-series
            name="StackedColumnSeries"
            #stackedColumnSeries
            [dataSource]="continentsBirthRate"
            [xAxis]="xAxis"
            [yAxis]="yAxis"
            showDefaultTooltip="false">
                <igx-stacked-fragment-series
                name="s1"
                #s1
                valueMemberPath="asia"
                title="Asia">
                </igx-stacked-fragment-series>
                <igx-stacked-fragment-series
                name="s2"
                #s2
                valueMemberPath="africa"
                title="Africa">
                </igx-stacked-fragment-series>
                <igx-stacked-fragment-series
                name="s3"
                #s3
                valueMemberPath="europe"
                title="Europe">
                </igx-stacked-fragment-series>
                <igx-stacked-fragment-series
                name="s4"
                #s4
                valueMemberPath="northAmerica"
                title="North America">
                </igx-stacked-fragment-series>
                <igx-stacked-fragment-series
                name="s5"
                #s5
                valueMemberPath="southAmerica"
                title="South America">
                </igx-stacked-fragment-series>
            </igx-stacked-column-series>
            <igx-data-tool-tip-layer
            name="DataToolTipLayer"
            #dataToolTipLayer>
            </igx-data-tool-tip-layer>
        </igx-data-chart>
    </div>

